import { RoadmapPortfolioDetails } from '@cfp/shared/roadmap';
import { ROADMAP_IMPLEMENTATION_YEARS_DISPLAY_START } from '@cfp/shared/roadmap/const';
import { RoadmapPortfolioDetailsDTO, RoadmapPortfolioDetailsTotalDTO } from 'csr-asset-app';

export function mapRoadmapPortfolioDetailsToRoadmapBuildingDetails(
  roadmapPortfolioDetails: RoadmapPortfolioDetailsDTO,
  roadmapImplementationYearsDisplayStart: number
): RoadmapPortfolioDetails {
  const startYear = roadmapImplementationYearsDisplayStart || ROADMAP_IMPLEMENTATION_YEARS_DISPLAY_START;

  return {
    co2ConsumptionBaseYear: roadmapPortfolioDetails.co2ConsumptionBaseYear,
    currencyCode: roadmapPortfolioDetails.currencyCode,
    gbTargetCo2Consumption2035: roadmapPortfolioDetails.gbTargetCo2Consumption2035,
    targetCo2Consumption2030: roadmapPortfolioDetails.targetCo2Consumption2030,
    targetCo2Consumption2050: roadmapPortfolioDetails.targetCo2Consumption2050,
    years: roadmapPortfolioDetails.totals.filter(
      (year: RoadmapPortfolioDetailsTotalDTO) => year.year === null || year.year >= startYear
    )
  };
}
